 function initializeTechnologyShowcase(section) {
    if (!section || section.dataset.techInitialized === 'true') {
      return;
    }

    section.dataset.techInitialized = 'true';

    const previewImage = section.querySelector('.tech-preview');
    const titleElement = section.querySelector('.tech-title');
    const descriptionElement = section.querySelector('.tech-desc');
    const tabs = section.querySelectorAll('.tech-tab');

    if (!previewImage || !titleElement || !descriptionElement || !tabs.length) {
      return;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('active')) {
          return;
        }

        const newImage = tab.dataset.image;
        const newTitle = tab.dataset.title;
        const newDescription = tab.dataset.desc;

        tabs.forEach(function (item) {
          item.classList.remove('active');
          item.setAttribute('aria-pressed', 'false');
        });

        tab.classList.add('active');
        tab.setAttribute('aria-pressed', 'true');

        titleElement.textContent = newTitle || '';
        descriptionElement.textContent = newDescription || '';

        if (!newImage || previewImage.getAttribute('src') === newImage) {
          return;
        }

        previewImage.classList.add('is-changing');

        const nextImage = new Image();

        nextImage.onload = function () {
          window.setTimeout(function () {
            previewImage.src = newImage;
            previewImage.alt = (newTitle || 'Technology') + ' technology';

            requestAnimationFrame(function () {
              previewImage.classList.remove('is-changing');
            });
          }, 180);
        };

        nextImage.onerror = function () {
          previewImage.classList.remove('is-changing');
          console.warn('Technology image could not be loaded:', newImage);
        };

        nextImage.src = newImage;
      });
    });
  }

  function initializeAllTechnologyShowcases(container) {
    const scope = container || document;

    if (
      scope.classList &&
      scope.classList.contains('technology-showcase')
    ) {
      initializeTechnologyShowcase(scope);
    }

    scope
      .querySelectorAll('.technology-showcase')
      .forEach(initializeTechnologyShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllTechnologyShowcases(document);
    });
  } else {
    initializeAllTechnologyShowcases(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllTechnologyShowcases(event.target);
  });





